import { apiPatch } from '@/api/api.ts'
import { AlertPatchType } from '@/api/notification/alertServerValues.ts'

export interface IReqPatchBioAlertAssignPerson {
    manager_name: string;
}

export const apiPatchBioAlertAssignPerson = async (id: number, params: IReqPatchBioAlertAssignPerson) => {
    return await apiPatch<undefined>(`/alert/bio/${id}`, {
        type: AlertPatchType.ASSIGN,
        manager_name: params.manager_name
    })
}

export interface IReqPatchBioAlertProcess {
    task_content: string;
    task_result: string;
}

export const apiPatchBioAlertProcess = async (id: number, params: IReqPatchBioAlertProcess) => {
    return await apiPatch<undefined>(`/alert/bio/${id}`, {
        type: AlertPatchType.CONFIRM,
        task_result: params.task_result,
        task_content: params.task_content
    })
}

